import script from "./module-layout.vue?vue&type=script&lang=js"
export * from "./module-layout.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/module-layout.vue'],['__file',"module-layout.vue"]])

export default __exports__